export const NEW_MESSAGES_COUNTER = 'NEW_MESSAGES_COUNTER';
export const NEW_MESSAGES_COUNTER_SUCCESS = 'NEW_MESSAGES_COUNTER_SUCCESS';
export const NEW_MESSAGES_COUNTER_FAILED = 'NEW_MESSAGES_COUNTER_FAILED';

export const NEW_CHATS_MESSAGES = 'NEW_CHATS_MESSAGES';
export const NEW_CHATS_MESSAGES_SUCCESS = 'NEW_CHATS_MESSAGES_SUCCESS';
export const NEW_CHATS_MESSAGES_FAILED = 'NEW_CHATS_MESSAGES_FAILED';

export const ADD_PLUS_ONE_TO_CHAT_COUNTER = 'ADD_PLUS_ONE_TO_CHAT_COUNTER';
